import React from 'react';
import {
  Box,
  Container,
  Heading,
  Text,
  HStack,
  VStack,
  SimpleGrid,
} from '@chakra-ui/react';
import VideoBackground from './VideoBackground';

const Hero: React.FC = () => {
  const stats = [
    { value: '5+', label: 'Premium Brands' },
    { value: '100+', label: 'Product Variants' },
    { value: '50+', label: 'Retail Partners' },
  ];

  return (
    <Box
      id="home"
      position="relative"
      minH="100vh"
      display="flex"
      alignItems="center"
      justifyContent="center"
      bgGradient="linear(to-br, brand.500, brand.600)"
      overflow="hidden"
      pt={20}
    >
      {/* Video Background */}
      <VideoBackground />

      <Container maxW="1200px" position="relative" zIndex={2}>
        <VStack spacing={8} textAlign="center" color="white" py={20}>
          <VStack spacing={6} maxW="800px">
            <Heading
              fontSize={{ base: '4xl', md: '6xl', lg: '8xl' }}
              fontWeight="700"
              lineHeight="1.2"
              textShadow="0 2px 4px rgba(0,0,0,0.3)"
            >
              Daily-Dynamic Trading Co.
            </Heading>

            <Text
              fontSize={{ base: 'lg', md: 'xl' }}
              maxW="600px"
              opacity={0.9}
              lineHeight="1.6"
            >
              Your trusted partner for quality product distribution and trading solutions across the region.
            </Text>
          </VStack>

          <SimpleGrid
            columns={{ base: 1, md: 3 }}
            spacing={8}
            w="100%"
            maxW="600px"
            pt={8}
          >
            {stats.map((stat, index) => (
              <Box
                key={index}
                p={6}
                bg="whiteAlpha.100"
                borderRadius="xl"
                backdropFilter="blur(10px)"
                border="1px solid"
                borderColor="whiteAlpha.200"
                transition="all 0.3s"
                _hover={{
                  transform: 'translateY(-5px)',
                  bg: 'whiteAlpha.200',
                }}
              >
                <Heading size="lg" mb={2}>
                  {stat.value}
                </Heading>
                <Text fontSize="md" opacity={0.9}>
                  {stat.label}
                </Text>
              </Box>
            ))}
          </SimpleGrid>
        </VStack>
      </Container>
    </Box>
  );
};

export default Hero;
